import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/packages/bySlug.ts
import { getLocaleOnly, uuid } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var QUEUE_SESSION_HEADER = "queue-token";
var getPackageBySlug = (_0) => __async(null, [_0], function* ({ slug, lang }) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const response = yield fetchClient({
      url: `/bundles/${slug}?${params.toString()}`,
      queue: slug,
      raw: true
    });
    const sessionId = response.headers.get(QUEUE_SESSION_HEADER) || "";
    const data = yield response.json();
    if (!response.ok) {
      if (!data.message) {
        data.message = (data == null ? void 0 : data.error) || "Something went wrong";
      }
      data.statusCode = response.status;
      throw data;
    }
    return __spreadProps(__spreadValues({}, data.data), {
      conditions: data.data.conditions.map((cond) => __spreadProps(__spreadValues({}, cond), {
        condition_items: cond.condition_items.sort((a, b) => +b.capacity - +a.capacity).map((ci) => __spreadProps(__spreadValues({}, ci), {
          _id: uuid()
        }))
      })),
      _queue: data._queue,
      sessionId
    });
  } catch (error) {
    throw new Exception({
      error,
      name: "getPackageBySlugException"
    });
  }
});

export {
  getPackageBySlug
};
//# sourceMappingURL=chunk-CIE4FB47.mjs.map